var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({class:{'btn-sm' : _vm.small}},'b-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }